import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import IconStyles from "components/icons/Icon.module.scss";

export const Heart = ({size, fill, className, id}) => {
  let _attributes = {};
  _attributes.viewBox = "0 0 48 48";
  _attributes.width = _attributes.height = size || 48;
  if (id.trim() !== "") _attributes.id = id;
  if (className) {
    _attributes.className = classnames(IconStyles["icon"], className);
  } else {
    _attributes.className = IconStyles["icon"];
  }

  return (
    <svg {..._attributes}>
      <rect className={IconStyles["icon__canvas"]} x={"0"} y={"0"} width={"48"} height={"48"}/>
      <path d="M40.808,8.246c-4.464,-3.805 -11.104,-3.121 -15.202,1.108l-1.605,1.654l-1.605,-1.654c-4.09,-4.229 -10.738,-4.913 -15.203,-1.108c-5.117,4.367 -5.385,12.204 -0.807,16.938l15.765,16.278c1.019,1.051 2.672,1.051 3.691,0l15.765,-16.278c4.587,-4.734 4.318,-12.571 -0.799,-16.938Z" fillRule={"nonzero"} fill={fill}/>
    </svg>
  );
};

Heart.defaultProps = {
  size: 48,
  fill: "#ee2f7d",
  className: "",
  id: ""
};

Heart.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  fill: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  id: PropTypes.string
};
